import type { ButtonProps } from '@mui/material';
import { Button, styled, Typography } from '@mui/material';
import React from 'react';

import theme from '@/styles/theme';

// textCenterがtrueの場合は、textを中央に表示する
// iconがある場合は、textとiconを左右に表示する
type Props = ButtonProps & {
  text: string;
  icon?: React.ReactNode;
  textCenter?: boolean;
  fontweight?: number;
  fontsize?: number;
};

const StyledButton = styled(Button)`
  justify-content: space-between;
  padding: ${theme.spacing(2)};
  width: 100%;
  border: solid 1px ${theme.palette.primary.main};
  border-radius: 8px;
`;

const OutLineButton = ({
  text,
  icon,
  textCenter,
  fontweight,
  fontsize,
  ...args
}: Props) => {
  return (
    <StyledButton {...args}>
      <Typography
        fontSize={fontsize ? `${fontsize}px` : '16px'}
        fontWeight={fontweight ? `${fontweight}` : 'bold'}
        color="primary"
        sx={{ margin: textCenter ? '0 auto' : '0' }}
      >
        {text}
      </Typography>
      {icon}
    </StyledButton>
  );
};

export default OutLineButton;
